<template>
  <el-dialog
    title="비밀번호 변경"
    :visible.sync="dialogVisible"
     width="30%"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    class="force-pass-title"
    modal-class="force-pass-modal"
    >
    <el-form v-loading="loadingFlag" class="mr-b30" label-position="top" :model="passwordFormDatas" :rules="rules" ref="userPasswordForm">
      <div class="mr-b20">
        <el-form-item label="현재 비밀번호" prop="password">
          <el-input type="password" v-model="passwordFormDatas.password"></el-input>
        </el-form-item>
      </div>
      <div class="mr-b20">
        <el-form-item label="새 비밀번호" prop="modifyPassword">
          <el-input type="password" v-model="passwordFormDatas.modifyPassword"></el-input>
        </el-form-item>
      </div>
      <el-form-item label="변경된 비밀번호 확인" prop="checkPassword">
        <el-input type="password" v-model="passwordFormDatas.checkPassword"></el-input>
      </el-form-item>
    </el-form>
    <el-row class="mr-t10" type="flex" justify="space-between">
      <span>비밀번호를 변경한지 <em>{{pwChangeDay}}</em>일이 지났습니다.</span>
      <el-button size="small" type="solid" @click="onClickUpdateUserAccount">변경</el-button>
    </el-row>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { isNil, isEqual, cloneDeep } from 'lodash';
import { validatePassword } from '@/utils/string';
import rsaEncrypt from '@/utils/rsa-encrypt';
import UserSettingAPI from '@/api/settings/user/user-setting';
import msgUtil from '@/utils/message';
import userAPI from '@/api/frame/user';

export default {
  name: 'WForcePasswordChangePopup',
  data() {
    return {
      dialogVisible: false,
      loadingFlag: false,
      pwChangeDay: 1, // init
      accountFormDatas: {},
      passwordFormDatas: {
        password: '', // 현재
        modifyPassword: '', // 수정
        checkPassword: '', // 확인
      },
      policyObject: {
        PASSWORDCHANGINGTYPE: 'PASSWORDINIT',
      },
      rules: {
        password: {
          required: true,
          validator: this.validateCurrentPassword,
          trigger: 'blur',
        },
        modifyPassword: {
          required: true,
          validator: this.validatePassword,
          trigger: 'blur',
        },
        checkPassword: {
          required: true,
          validator: this.validateNewPasswordConfirm,
          trigger: 'blur',
        },
      },
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  methods: {
    /**
     * [비밀번호 변경창을 띄우며 필요한 데이터를 조회한다.]
     * @author Song
     */
    open(pwChangeDay) {
      this.pwChangeDay = pwChangeDay;
      this.dialogVisible = true;
      this.loadingFlag = true;
      //
      userAPI
        .getUserAccountList()
        .then((result) => {
          if (result.data.success === true) {
            this.accountFormDatas = cloneDeep(result.data.data);
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '사용자 정보', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '사용자 정보', false));
        });
      // 계정보안정책 - 패스워드 보안 정책 조회 및 세팅
      UserSettingAPI.getAllAccountPolicyList()
        .then((response) => {
          if (response.data.success) {
            if (!isNil(response.data.data)) {
              response.data.data.forEach((item) => {
                const policyType = item.basicinfoSubid;
                const dataType = item.datatypeId;
                if (isEqual(dataType, 'STRING')) {
                  this.policyObject[policyType] = item.basicinfoSubvalueString;
                } else if (isEqual(dataType, 'BOOL')) {
                  this.policyObject[policyType] = Number(item.basicinfoSubvalueBoolean);
                  if (isEqual(policyType, 'SECURITYWEAKPATTERNCHECK')) {
                    this.policyObject.PATTERN = item.basicinfoSubvalueString;
                  }
                } else if (isEqual(dataType, 'INTEGER')) {
                  this.policyObject[policyType] = item.basicinfoSubvalueInteger;
                }
              });
            }
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '계정 보안 정책 정보', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '계정 보안 정책 정보', false));
        })
        .finally(() => {
          this.loadingFlag = false;
        });
    },
    /**
     * [비밀번호 변경후 저장한다.]
     * @author Song
     */
    onClickUpdateUserAccount() {
      this.$refs.userPasswordForm.validate((valid) => {
        if (valid) {
          this.updateUserPasswordInfo();
          return true;
        }
        return false;
      });
    },
    /**
     * [비밀번호 변경 저장 - 기존 사용자 정보 변경 팝업창 > 비밀번호 변경과 동일]
     * @author Song
     */
    updateUserPasswordInfo() {
      const fieldData = {
        managerId: this.userInfo.managerId,
        password: this.passwordFormDatas.modifyPassword,
      };
      rsaEncrypt.getRsaEncrypt(fieldData).then((encryData) => {
        const params = {
          managerId: encryData.managerId,
          password: encryData.password,
        };
        UserSettingAPI.changePassword(params).then(() => {
          this.$message('비밀번호가 변경되었습니다.');
          this.dialogVisible = false;
          this.$emit('change-password');
        });
      });
    },
    /**
     * [현재 로그인 계정의 비밀번호와 일치하는지 유효성 체크]
     * @author Song
     */
    validateCurrentPassword(rule, value, callback) {
      if (isNil(value) || isEqual(value.length, 0)) {
        callback(new Error('비밀번호를 입력해주세요.'));
      } else {
        const fieldInfo = {
          password: this.passwordFormDatas.password,
        };
        rsaEncrypt.getRsaEncrypt(fieldInfo).then((encryData) => {
          const params = {
            password: encryData.password,
          };
          UserSettingAPI.checkAdminPassword(params).then((response) => {
            if (response.data.data) {
              callback();
            } else {
              callback(new Error('비밀번호가 맞지 않습니다.'));
            }
          });
        });
      }
    },
    /**
     * [비밀번호 정책과 계정정보를 전달하여 신규 비밀번호가 정책에 맞는지 유효성 체크]
     * @author Song
     */
    validatePassword(rule, value, callback) {
      const result = validatePassword(value, this.policyObject, this.accountFormDatas);
      if (result.valid) {
        callback();
      } else {
        callback(new Error(result.message));
      }
    },
    /**
     * [새로운 비밀번호 - 확인 비밀번호 일치 여부]
     * @author Song
     */
    validateNewPasswordConfirm(rule, value, callback) {
      if (isNil(value) || value.length <= 0) {
        callback(new Error('비밀번호를 입력해주세요.'));
      } else {
        const password = this.passwordFormDatas.modifyPassword;
        if (isNil(password) || password.length <= 0) {
          callback(new Error('비밀번호를 입력해주세요.'));
        }
        if (!isEqual(value, password)) {
          callback(new Error('비밀번호가 일치하지 않습니다.'));
        }
      }
      callback();
    },
  },
};
</script>

<style>
.force-pass-title {
  top: 150px;
}
.force-pass-title .el-dialog .el-dialog__header {
  border-bottom: 1px solid #e0e0e0;
}
.force-pass-modal {
  top: 0px;
  left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/frame/components/popup/ForcePasswordChangePopup.vue